module.exports = __webpack_public_path__ + "7fce0d4b364d8f52ac61da2a09ef7739.pdf";